// Multipage form render / show form and initial back button

// Function to update button attributes
function updateButton(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const selectedValue = selectedOption.value;
    const selectedValueName = selectedOption.innerText;
    const selectedValueButtonText = selectedOption.dataset.buttonText;
    const closestFormIndexDiv = selectElement.closest('div[data-form-index]');

    if (closestFormIndexDiv) {
        const button = closestFormIndexDiv.querySelector('[data-toggle-form-index]');
        if (button) {
            button.setAttribute('data-toggle-form-index', selectedValue);
            button.setAttribute('data-toggle-form-name', selectedValueName);
            button.querySelector('span').innerHTML = selectedValueButtonText;
            button.setAttribute('data-description', 'Click to ' + selectedValueButtonText.toLowerCase());
        }
    }
}

// Function to handle default selection based on URL query
function handleDefaultSelection(conversionHeaderPanel) {
    const selectField = conversionHeaderPanel.querySelector('select[name="form-selector"]');
    if (!selectField) return;

    const urlParams = new URLSearchParams(window.location.search);
    const helpWithQuery = urlParams.get('helpwith');

    if (helpWithQuery) {
        for (let option of selectField.options) {
            if (option.getAttribute('data-active-query') === helpWithQuery) {
                selectField.value = option.value;
                break;
            }
        }
        updateButton(selectField); // Update button on load
    }

    // Add event listener to update button data on select change
    selectField.addEventListener('change', function (event) {
        updateButton(event.target);
    });
}

// Function to handle the hiding content logic on load
function handleInitialContentHiding() {
    const initialHiddenContents = document.querySelectorAll('[data-hide-on-load]');
    initialHiddenContents.forEach(initialHiddenContent => {
        const timeoutDuration = parseInt(initialHiddenContent.dataset.hideOnLoad, 10);
        const validTimeout = isNaN(timeoutDuration) ? 3000 : timeoutDuration;

        setTimeout(() => {
            initialHiddenContent.removeAttribute('style');
            setTimeout(() => {
                initialHiddenContent.dataset.hideOnLoad = 'complete';
            }, 100);
        }, validTimeout);
    });
}

// Function to handle form toggling
function handleFormToggle() {
    document.addEventListener('click', (event) => {
        const resizeEvent = new Event('resize');

        const target = event.target.closest('[data-toggle-form-index]');
        if (target) {
            const showFormContainer = target.closest('[data-show-form-index]');
            const toggleFormIndex = target.dataset.toggleFormIndex;
            const toggleFormName = target.dataset.toggleFormName;

            if (showFormContainer && toggleFormIndex) {
                showFormContainer.dataset.showFormIndex = toggleFormIndex;

                if (showFormContainer.querySelector(`[data-form-index="${toggleFormIndex}"] form input[name="formOptionSelected"]`)) {
                    showFormContainer.querySelector(`[data-form-index="${toggleFormIndex}"] form input[name="formOptionSelected"]`).value = toggleFormName;
                }

                // Scroll form into view for mobile screens
                if (window.innerWidth < 768) {
                    showFormContainer.scrollIntoView({ behavior: 'smooth' });
                }
            }

            window.dispatchEvent(resizeEvent);
        }
    });
}

window.addEventListener('load', function () {
    const conversionHeaderPanels = document.querySelectorAll('.conversion-header-panel');

    // Execute logic if there are conversion panels
    if (conversionHeaderPanels.length) {
        handleInitialContentHiding(); // Handle hiding elements on load
        handleFormToggle(); // Handle form toggle

        conversionHeaderPanels.forEach(conversionHeaderPanel => {
            handleDefaultSelection(conversionHeaderPanel); // Handle default selection and update
        });
    }
});